module.exports = __webpack_public_path__ + "static/img/role002.db165aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role002.jpg
// module id = OM9Z
// module chunks = 1